import { pages } from "@routes/pages";

import { CustomerTypeItem } from "../CustomerTypeItem";
import { typesManagementPageFor } from "../typesManagementPageFor";

export default typesManagementPageFor(CustomerTypeItem, pages.customerTypes);
